import axios from "axios";
import { ENDPOINT } from "constants/environment";
import { encryptData } from "helpers";
import { decryptData } from "helpers";
import { getHeaderConfig } from "helpers";
import { consoleLog } from "helpers";

export const getOnboardTemplatesAPI = async (
  { pageIndex, skip },
  isLoading,
  accessJWT
) => {
  try {
    isLoading(true);
    const config = getHeaderConfig(null, accessJWT);

    const body = {
      skip: pageIndex + 1,
      limit: skip,
    };

    const response = await axios.post(
      `${ENDPOINT}/app/v1/template/getAll`,
      encryptData(body),
      config
    );
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData && parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);
      consoleLog([parsedResponseData, "response"]);
      return parsedResponseData?.data;
    }
    if (isLoading) isLoading(false);
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error fetching data:", error);
    return null;
  }
};

export const getFilterOnboardTemplateAPI = async (
  { searchQuery, pageIndex, limit },
  payload,
  isLoading,
  accessJWT
) => {
  try {
    isLoading(true);
    const config = getHeaderConfig(null, accessJWT);

    const body = {
      searchQuery,
      skip: pageIndex + 1,
      limit: limit || 10,
    };

    const response = await axios.post(
      `${ENDPOINT}/app/v1/onbaord/search`,
      encryptData(body),
      config
    );

    const parsedResponseData = JSON.parse(decryptData(response?.data));

    if (parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);
      consoleLog([parsedResponseData.data, "searchRes"]);
      consoleLog([
        parsedResponseData.data.pagination?.totalPages,
        "parsedResponseData.data.pagination?.totalPages",
      ]);

      return {
        data: parsedResponseData?.data.data,
        totalPages: parsedResponseData.data.pagination?.totalPages,
      };
    }

    if (isLoading) isLoading(false);
    throw new Error("Error fetching data");
  } catch (error) {
    isLoading(false);
    console.error("Error fetching data:", error);
    return { data: [], totalPages: 0 };
  }
};

export const createOrUpdateOnboardTemplateAPI = async (
  args,
  isLoading,
  accessJWT
) => {
  const API_URL = `${ENDPOINT}/app/v1/template/create`;
  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const response = args?.id
      ? await axios.put(API_URL, encryptData(args), config)
      : await axios.post(API_URL, encryptData(args), config);
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData && parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);
      return { success: true, data: parsedResponseData?.data };
    } else {
      if (isLoading) isLoading(false);
      return {
        success: false,
        message: parsedResponseData?.message || "Unknown error occurred",
      };
    }
  } catch (error) {
    if (isLoading) isLoading(false);
    console.error("Error creating/updating template:", error);

    if (error.response && error.response.data) {
      const backendMessage = error.response.data.message || "Unknown error";
      return { success: false, message: backendMessage };
    }

    return { success: false, message: "Network or server error" };
  }
};

export const updateOnboardTemplateAPI = async (args, isLoading, accessJWT) => {
  const API_URL = `${ENDPOINT}/app/v1/template/update`;
  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);

    const payload = {
      id: args?.id,
      status: args?.status,
    };

    const response = await axios.post(API_URL, encryptData(payload), config);
    const parsedResponseData = JSON.parse(decryptData(response?.data));

    if (parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);
      return { success: true, data: parsedResponseData?.data };
    } else {
      if (isLoading) isLoading(false);
      return {
        success: false,
        message: parsedResponseData?.message || "Unknown error occurred",
      };
    }
  } catch (error) {
    if (isLoading) isLoading(false);
    console.error("Error updating template:", error);
    const backendMessage =
      error.response?.data?.message || "Network or server error";
    return { success: false, message: backendMessage };
  }
};

export const deleteOnboardTemplateAPI = async (args, isLoading, accessJWT) => {
  const API_URL = `${ENDPOINT}/app/v1/template/id`;
  consoleLog([args, "args"]);

  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);

    const body = { id: args.id };

    const response = await axios.post(API_URL, encryptData(body), config); //
    const parsedResponseData = JSON.parse(decryptData(response?.data));

    if (parsedResponseData) {
      if (isLoading) isLoading(false);
      return parsedResponseData;
    }

    if (isLoading) isLoading(false);
    throw new Error("Error deleting template");
  } catch (error) {
    if (isLoading) isLoading(false);
    console.error("Error deleting template:", error);
    return null;
  }
};
